import axios from "axios";

const state = () => ({
  id: 0,
  product: {},
  loading_is_complete: false,
});

const getters = {
  GET_LOADING_IS_COMPLETE(state) {
    return state.loading_is_complete;
  },
  GET_PRODUCT: (state) => {
    return state.product;
  },

  GET_ID: (state) => {
    return state.product.id;
  },

  GET_IMAGES: (state) => {
    if (state.loading_is_complete) return state.product.images;
    else return [];
  },
  GET_IMAGES_LENGTH: (state) => {
    if (state.loading_is_complete) return state.product.images.length;
    else return 0;
  },
  GET_PROPERTIES: (state) => {
    if (state.loading_is_complete) return state.product.properties;
    else return [];
  },
  GET_SPECIFICATION: (state) => {
    return state.product.specification;
  },

  GET_ANALOGS: (state) => {
    if (state.loading_is_complete) return state.product.analogs;
    else return [];
  },
  GET_ANALOGS_LENGTH: (state) => {
    if (state.loading_is_complete) return state.product.analogs.length;
    else return 0;
  },
};

const mutations = {
  SET_DATA: (state, data) => {
    state.product = data;
  },
  SET_LOADING_IS_COMPLETE: (state, loading_is_complete) => {
    state.loading_is_complete = loading_is_complete;
  },
};

const actions = {
  FETCH_PRODUCT: ({ commit, dispatch }, slug) => {
    commit("SET_LOADING_IS_COMPLETE", false);
    let slug2 = slug.split('-').join('_');
    axios
      .get(`${process.env.VUE_APP_API_URL}products/${slug2}`)
      .then(function (response) {
        // console.log(response.data)
        // console.log("FETCH_PRODUCT")

        commit("SET_LOADING_IS_COMPLETE", true);
        commit("SET_DATA", response.data);

        dispatch(
          "bread_crumbs/SET_FOR_PRODUCT",
          {
            slug: slug,
            name: response.data.name_crumb,
            parent: response.data.category,
          },
          { root: true }
        );
      })
      .catch(function (error) {
        console.error(error);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
